import React from 'react';

import { makeStyles, Snackbar, Typography, Box } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

const useStyles = makeStyles({
  snackbarContainer: {
    display: 'flex',
    alignItems: 'center',
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    padding: '32px',
  },
  checkIcon: {
    color: '#4b8c6f',
    backgroundColor: '#eaf2ef',
    border: '1px solid #4b8c6f',
    borderRadius: '100%',
    width: '28px',
    height: '28px',
    padding: '4px',
    marginRight: '15px',
  },
  title: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: 1.3,
    letterSpacing: '0.26px',
    marginBottom: '8px',
  },
  subTitle: {
    color: '#a4a8ac',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 1.36,
  },
});

export const CodeSentSnackbar = ({ isOpen, onClose }) => {
  const classes = useStyles();

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={isOpen}
      autoHideDuration={6000}
      onClose={onClose}
    >
      <Box className={classes.snackbarContainer}>
        <CheckIcon classes={{ root: classes.checkIcon }} />
        <div>
          <Typography classes={{ root: classes.title }}>
            Verification Code Sent Successfully{' '}
          </Typography>
          <Typography classes={{ root: classes.subTitle }}>
            A verification code has been sent to your mail id and Mobile Number.
          </Typography>
        </div>
      </Box>
    </Snackbar>
  );
};
